import { Directive, HostListener, ElementRef, Input } from '@angular/core';

@Directive({
  selector: '[appPhoneNumberFormatter]'
})
export class PhoneNumberFormatterDirective {
  @Input('appPhoneNumberFormatter') formattedNumber: string = ''; // Initial value for edit mode

  constructor(private el: ElementRef) {}

  ngOnInit() {
    if (this.formattedNumber) {
      this.el.nativeElement.value = this.formatPhoneNumber(this.formattedNumber);
    }
  }

  @HostListener('input', ['$event']) onInput(event: any) {
    let input = this.el.nativeElement.value.replace(/\D/g, ''); // Remove all non-digit characters
    
    if (input.length > 10) {
      input = input.substring(0, 10); // Allow only 10 digits
    }

    this.el.nativeElement.value = this.formatPhoneNumber(input);

    // Trigger 'input' event to update ngModel or formControl
    this.el.nativeElement.dispatchEvent(new Event('input'));
  }

  private formatPhoneNumber(phoneNumber: string): string {
    let formatted = '';

    const areaCode = phoneNumber.substring(0, 3);
    const middle = phoneNumber.substring(3, 6);
    const last = phoneNumber.substring(6, 10);

    if (phoneNumber.length > 6) {
      formatted = `(${areaCode}) ${middle}-${last}`;
    } else if (phoneNumber.length > 3) {
      formatted = `(${areaCode}) ${middle}`;
    } else if (phoneNumber.length > 0) {
      formatted = `(${areaCode}`;
    }

    return formatted;
  }
}
